import { isFunction, isUef } from "../utils";

let observer;
const observerTaskMap = new Map();

function initObserver(cb) {
  if (observer) return observer;
  const instance = new IntersectionObserver(cb);
  observer = {
    instance: instance,
    observe(target, cb) {
      observerTaskMap.set(target, cb);
      instance.observe(target);
    },
    unobserve(target) {
      observerTaskMap.delete(target);
      instance.unobserve(target);
    },
    disconnect() {
      instance.disconnect();
    },
    destroy() {
      instance.disconnect();
      observerTaskMap.clear();
      observer = undefined;
    },
  };
}

export default {
  name: 'coverage',

  inserted(el, binding, vnode) {

    if (isUef(observer)) {
      initObserver((entries) => {
        entries.forEach((entry) => {
          const cb = observerTaskMap.get(entry.target);

          if (isFunction(cb)) {
            cb(entry);
          }
        });
      });
    }
    observer.observe(el, binding.value);
  },

  unbind(el) {
    observer.unobserve(el);
    if (observerTaskMap.size < 1) {
      observer.destroy();
    }
  },
}
